import ModalConfirm from "../../../../components/Modals/Generales/ModalConfirm";
import BasicCardDocumentos from "./BasicCardDocumentos";
import { useState } from "react";
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { actionsCierreFiscal } from "../../../../actions/action-creators";
import { generalOpenToastError } from "../../../../actions/general.actions";
import * as validators from '../../../../utils/validaciones'

export default function FormularioCierre (){
    const dispatch = useDispatch()
    const defaultValue = {startDate: '', endDate: '', email: ''}
    const [data, setData] = useState(defaultValue);
    const [errors, setErrors] = useState(defaultValue)
    const [modalAdvertencia, setModalAdvertencia] = useState(false)
    const { CerrarPeriodoFiscal } = bindActionCreators(actionsCierreFiscal, dispatch)

    const onChangeHandler = async (e: any) => {
        e.preventDefault();
        let {name, value} = e.target;
        const errorMessage = HandleValidationError(e);
        setData(prevData => ({
            ...prevData,
            [name]: value
        }));
        setErrors(prevData => ({
            ...prevData,
            [name]: errorMessage
        })); 
    }

    const handleCerrarPeriodo = () => {
        setModalAdvertencia(false);
        const body = {startDate: convertirFecha(data?.startDate), endDate: convertirFecha(data?.endDate), email: data?.email};
        CerrarPeriodoFiscal(body);
    }

    const handleOpenWarning = async () => {
        if (!validarVacios()) return; 
        if (await validationData(data, errors)) setModalAdvertencia(true);
    }

    const validarVacios = () => {
        if (data?.startDate === ''){
            dispatch(generalOpenToastError('La fecha inicial no puede estar vacía'));
            setErrors(prevData => ({...prevData, startDate: 'La fecha inicial no puede estar vacía'}));
            return false;
        }
        if (data?.endDate === ''){
            dispatch(generalOpenToastError('La fecha final no puede estar vacía'));
            setErrors(prevData => ({...prevData, endDate: 'La fecha final no puede estar vacía'}));
            return false;
        }
        if (data?.email === ''){
            dispatch(generalOpenToastError('El correo electrónico no puede estar vacío'));
            setErrors(prevData => ({...prevData, email: 'El correo electrónico no puede estar vacío'}));
            return false;
        }
        return true;
    }

    const validationData = (data: any, errors: any) => {
        let errorFlag = true;
        for (let err of Object.values(errors)) {
            if (err !== '' ) {
                dispatch(generalOpenToastError('Los datos de cierre contienen valores incorrectos'));
                return false;
            }
        }
        if (!fechaMayor(data?.endDate, data?.startDate)){
            dispatch(generalOpenToastError('La fecha final debe ser mayor a la fecha inicial'));
            return false;
        }
        if(errorFlag) return true;
        return false;
    }

    const fechaMayor = (fecha1: string, fecha2: string) => {
        const fecha1Obj = new Date(fecha1);
        const fecha2Obj = new Date(fecha2);
        if (fecha1Obj > fecha2Obj) return true;
        return false
    }

    const HandleValidationError = (e: any) => {
        e.preventDefault();
        let {name, value} = e.target
        let message = ''
        switch (name) {
          case 'startDate':
            const startDate = new Date(value);
            if (isNaN(startDate.getTime())) {
                message = 'La fecha contiene valores incorrectos'
            }
            break
          case 'endDate':
            const endDate = new Date(value);
            if (isNaN(endDate.getTime())) {
                message = 'La fecha contiene valores incorrectos'
            }
            break
          case 'email':
            message = validators.validacionEmail(value, message, 'Correo electrónico')
            break
          default:
            break
        }
        return message;
    }

    const convertirFecha = (fecha: string) => {
        let partesFecha = fecha.split('-');
        let fechaTransformada = partesFecha[2] + '/' + partesFecha[1] + '/' + partesFecha[0];
        return fechaTransformada;
    }

    return (
        <>
        {modalAdvertencia && <ModalConfirm messageAction={'Aceptar'} actionConfirm = {handleCerrarPeriodo} closeModalConfirm = {() => setModalAdvertencia(false)} title = 'Cierre de periodo fiscal' detail = 'Esta operación solo puede realizarse una vez, por lo que si está seguro seleccione la opción Aceptar, de lo contrario puede cancelar.'/>}
        <div className="w-layout-layout bill-section wf-layout-layout">
        <BasicCardDocumentos style={{boxShadow: 'none', padding: '0'}} title="Datos de cierre" size="l">
            <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                    <label htmlFor='fechaInicial' className='field-label m'>Fecha inicial</label>
                    <input autoComplete='off' type='date' className='m text-field w-input' name='startDate' id='fechaInicial' value={data?.startDate} onChange={onChangeHandler} />
                    {errors.startDate && <p className='alert s'>{errors.startDate}</p>}
                </div>
                <div className='label-input'>
                    <label htmlFor='fechaFinal' className='field-label m'>Fecha final</label>
                    <input autoComplete='off' type='date' className='m text-field w-input' name='endDate' id='fechaFinal' value={data?.endDate} onChange={onChangeHandler} />
                    {errors.endDate && <p className='alert s'>{errors.endDate}</p>}
                </div>
            </div>
            <div className='w-layout-hflex h-inputs' style={{marginBottom: '2%'}}>
                <div className='label-input' style={{maxWidth: '49%'}}>
                    <label htmlFor='email' className='field-label m'>Correo electrónico</label>
                    <input autoComplete='off' type='email' className='m text-field w-input' name='email' data-name='Correo electrónico' placeholder='Correo electrónico' id='email' maxLength={50} value={data?.email} onChange={onChangeHandler}/>
                    {errors.email && <p className='alert s'>{errors.email}</p>}
                </div>
            </div>
            <div className="separador"/>
            <div>
                <p><b>Importante: </b>Al momento de confirmar la operación, se iniciará automáticamente un procedimiento destinado a compilar y enviarle, mediante correo electrónico, todos los archivos en formatos JSON y PDF correspondientes al período que ha seleccionado. El tiempo estimado para completar este proceso varía en función del volumen de documentos a procesar. Una vez que reciba el correo electrónico con los archivos adjuntos, dispondrá de un plazo de 48 horas para revisar los datos generados y comunicar cualquier incidencia o duda que pueda surgir. Transcurrido este plazo sin recibir comentarios por su parte, procederemos a eliminar la información enviada.</p>
                <p>Nota: Si quiere contratar más almacenamiento para su membresía puede contactar a <b>soporte@feles.app</b></p>
            </div>
            <div style={{display: 'flex', justifyContent: 'end'}}>
                <button className="button w-auto" onClick={handleOpenWarning}>Confirmar</button>
            </div>
        </BasicCardDocumentos>
        </div>
        </>
    );
}